import { Typography, TypographyProps } from 'antd'
import { FC } from 'react'
import { withPrefix } from 'src/sdk/contexts/Config'
import './ClickableText.less'

interface ClickableTextProps {
  text: string
  onClick: () => void
}

const ClickableText: FC<ClickableTextProps> = ({ text, onClick }) => {
  return (
    <Typography.Text className={withPrefix('typography-clickable')} onClick={onClick}>
      {text}
    </Typography.Text>
  )
}

export { ClickableText }
